import { siteStore } from "../store";

export const setSelectedWorkspaceId = (workspaceId: string | null) => (siteStore.selectedWorkspaceId = workspaceId);
